import { render } from "./TheDefaultLayout.vue?vue&type=template&id=6c39f3dd"
import script from "./TheDefaultLayout.vue?vue&type=script&lang=js"
export * from "./TheDefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__